/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, HFlow, Text, Theme, useTheme } from 'bold-ui'
import { ColorScale } from 'bold-ui/lib/styles/colors'
import { cloneElement, ReactElement } from 'react'

interface TipoCompartilhamentoButtonProps {
  isAtivo: boolean
  disabled?: boolean
  text: string
  color: ColorScale
  backgroundColor: string
  icon: ReactElement
  handleClick: () => void
}

export function TipoCompartilhamentoButton(props: Readonly<TipoCompartilhamentoButtonProps>) {
  const { isAtivo, handleClick, disabled, text, color, backgroundColor, icon } = props
  const theme = useTheme()
  const classes = getStyles(theme, color, isAtivo, backgroundColor, disabled)

  return (
    <Button size='large' style={classes.button} onClick={handleClick} disabled={disabled}>
      <HFlow hSpacing={0.5} alignItems='center'>
        <span css={classes.icon}>{cloneElement(icon, { width: '2.25rem', height: '2.25rem' })}</span>
        <Text fontWeight='bold' style={classes.text}>
          {text}
        </Text>
      </HFlow>
    </Button>
  )
}

const getStyles = (theme: Theme, color: ColorScale, isAtivo: boolean, backgroundColor: string, disabled?: boolean) => {
  const borderColor = disabled ? color.c80 : color.c40
  const border = isAtivo ? '0' : `1px solid ${borderColor}`
  const backgroundColorFinal = isAtivo ? backgroundColor : theme.pallete.gray.c100
  const hoverBackground = isAtivo ? backgroundColor : color.c100
  const textColorWhenEnabled = isAtivo ? theme.pallete.gray.c100 : color.c40
  const textColor = disabled ? color.c80 : textColorWhenEnabled

  return {
    button: css`
      width: 13.5rem;
      height: 3.25rem;
      padding: 0;
      min-inline-size: max-content;
      border: ${border};
      border-radius: 2px;
      background-color: ${backgroundColorFinal};

      &:not(:disabled):hover {
        background-color: ${hoverBackground};
      }
    `,
    text: css`
      color: ${textColor};
    `,
    icon: css`
      display: flex;
      align-items: center;
    `,
  }
}
